const state = {
 reload_company_health_check: false,
 reload_service_company_reports: false,
};

const actions = {};

const mutations = {
 RELOAD_COMPANY_HEALTH_CHECK(state, payload) {
  state.reload_company_health_check = payload.action;
 },
 RELOAD_SERVICE_COMPANY_REPORTS(state, payload) {
  state.reload_service_company_reports = payload.action;
 }
};

export default {
 state,
 actions,
 mutations
}
